import { render, staticRenderFns } from "./container-charts.vue?vue&type=template&id=b5bc9586"
import script from "./container-charts.vue?vue&type=script&lang=js"
export * from "./container-charts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports